const FAQS = [
  {
    id: 'f1',
    q: '五一吃瓜网主要追踪哪些类型的热门事件？',
    a: '我们覆盖网络热门事件的全品类，包括娱乐圈爆料、社会热点追踪、网络热搜事件、吃瓜事件汇总以及各类热门爆料。不管是明星八卦、网红翻车还是社会大事件，只要在网络上引发广泛讨论，我们都会第一时间追踪和整理。',
  },
  {
    id: 'f2',
    q: '网站的内容更新频率是怎样的？',
    a: '我们实行全天候热点监控机制，每日至少更新数十条最新网络热点。重大网络大事件发生时，团队会在 30 分钟内上线追踪报道，持续跟进事件进展直到尘埃落定。',
  },
  {
    id: 'f3',
    q: '如何确保吃瓜事件汇总的真实性和准确性？',
    a: '所有热门爆料和吃瓜事件汇总均来自公开网络信息，我们采用多信源交叉验证原则，对每条信息进行核实后再发布。对于尚未确认的消息，会明确标注"待证实"，让读者自行判断。',
  },
  {
    id: 'f4',
    q: '我可以在五一吃瓜网投稿或爆料吗？',
    a: '当然可以！我们非常欢迎热心网友提供线索。你可以通过页面的爆料投稿入口提交你发现的热门事件或最新网络热点，我们的编辑团队会及时审核并跟进。优质爆料还会获得首页推荐机会。',
  },
  {
    id: 'f5',
    q: '网站是否收费？如何第一时间获取更新？',
    a: '五一吃瓜网完全免费，无需注册即可浏览全部内容。建议将本站加入浏览器收藏夹，或关注每日更新的热门事件追踪板块。我们也会定期在首页推出热门专题合集，方便你一次性了解近期所有热点。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          吃瓜常见问答
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          关于五一吃瓜网，你想知道的都在这里
        </p>
        <div className="space-y-3">
          {FAQS.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 rounded-xl p-5 border border-background-200/60"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed pl-6">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}